// import { message } from 'antd';
import {
    all,
    call as sagaCall,
    delay,
    fork,
    put as sagaPut,
    putResolve,
    take,
    select,
    takeEvery as sagaTakeEvery,
    takeLatest as sagaTakeLatest,
    debounce,
} from 'redux-saga/effects';
import AppActions from "../redux/App/actions";
import { error401Handler } from '../redux/Logger/utils/error401Handler';
import NotificationActions from "../redux/Notification/actions";
import AuthActions from 'bukku/redux/Auth/actions';

class SagaContext {
    constructor(action = {}) {
        this.allow_intercept = false;
        this.action = action;
        this.isPdfByte = false;
    }
}

function* call(fn, path, data = null, context = new SagaContext()) {
    const request = {
        ...data,
        ...(context.allow_intercept || context.isPdfByte ? { context } : {}),
    };

    try {
        // console.log('aaa SAGA-SERVICE CALL 0', { fn, path, request });
        const response = yield sagaCall(fn, path, request);
        // console.log('aaa SAGA-SERVICE CALL 1', { response });
        // const {status} = response;
        // if (status === 200)
        //     message.info(`Successfully fetched with code 200 - ${context.action.type}`);
        yield sagaPut({ type: AppActions.CLOSE_INTERCEPTOR });
        return response;
    }
    catch (error) {
        // console.log('aaa SAGA-SERVICE CALL ERROR', { error });
        yield error401Handler(error, context, {
            actionsBlacklist: [
                // prevent infinite loop when sessionExpiredModal fails
                AuthActions.LOGIN_REQUEST,
            ],
            actionsNoRedispatchList: [
                NotificationActions.NOTIFICATION_SET_AS_READ_REQUEST,
            ],
        });
        throw error;
    }
}

function* put(action) {
    if (action.error) {
        const code = action.error.statusCode;
        const isInterceptCodes = code === 428 || code === 412;

        if (action.error.has_intercepted && isInterceptCodes) {
            const { has_intercepted } = action.error;
            console.log('aaa SAGASERVICE', has_intercepted);

            yield sagaPut({
                type: AppActions.OPEN_INTERCEPTOR,
                message: has_intercepted.message,
                items: has_intercepted.items,
                settings: has_intercepted.settings, // SPECIFIC FOR SETTINGS_CHECK
                interceptType: has_intercepted.intercept_type,
                action: has_intercepted.action,
                details: has_intercepted.details,
                // nonSupportedTransactionFees: has_intercepted.non_supported_transaction_fees,
                // statementNumbers: has_intercepted.statement_numbers,
            });
            return null;
        }

        if (!isInterceptCodes)
            yield put({ type: AppActions.CLOSE_INTERCEPTOR });

        // Surpress message.error for Timeout - as it is handled by SessionExpiryModal
        if (code === 401 && action.error.message === 'User is not authenticated / session time out, please try to login again.')
            return null;

        console.error(action.error);
    }
    yield sagaPut(action);
    return null;
}

function* takeEvery(pattern, worker) {
    yield sagaTakeEvery(pattern, function* (action) {
        const context = new SagaContext(action);
        yield worker(action, context);
    });
}

function* takeLatest(pattern, worker) {
    yield sagaTakeLatest(pattern, function* (action) {
        const context = new SagaContext(action);
        yield worker(action, context);
    });
}

export {
    all,
    take,
    takeEvery,
    fork,
    put,
    putResolve,
    call,
    select,
    delay,
    takeLatest,
    debounce,
    SagaContext,
};
